export default __webpack_public_path__ + "static/media/Date.15484f9a.png";